import React from 'react';
import ModalFrame from '../../dashboard/components/product_item_components/ModalFrame';
import '../../dashboard/Dashboard.css';
import { BUSINESS_COLORS, businessColorById } from '../../../types/BusinessColorTypes';
import './BusinessColorField.css';

export default function BusinessColorField({ colorType, onColorTypeChange, disabled }) {
  const [isOpen, setIsOpen] = React.useState(false);
  const selected = businessColorById(colorType);

  return (
    <section className="shop-create-section">
      <div className="shop-create-label">Тема сайта</div>
      <div className="shop-create-help">Цвет витрины для покупателей</div>
      <button
        type="button"
        className="shop-color-button"
        onClick={() => setIsOpen(true)}
        disabled={disabled}
        aria-haspopup="dialog"
        aria-expanded={isOpen}
      >
        <span
          className="shop-color-swatch"
          style={{ background: selected.swatch }}
          aria-hidden="true"
        />
        <span className="shop-color-name">{selected.name}</span>
      </button>

      {isOpen ? (
        <ModalFrame title="Тема сайта" onClose={() => setIsOpen(false)}>
          <div className="main-page-modalList" role="listbox">
            {BUSINESS_COLORS.map((color) => {
              const selectedOption = color.id === selected.id;
              return (
                <button
                  key={color.id}
                  type="button"
                  role="option"
                  aria-selected={selectedOption}
                  className={
                    selectedOption
                      ? 'main-page-modalItem main-page-modalItemSelected shop-color-option'
                      : 'main-page-modalItem shop-color-option'
                  }
                  onClick={() => {
                    onColorTypeChange?.(color.id);
                    setIsOpen(false);
                  }}
                >
                  <span
                    className="shop-color-swatch"
                    style={{ background: color.swatch }}
                    aria-hidden="true"
                  />
                  <span className="shop-color-name">{color.name}</span>
                </button>
              );
            })}
          </div>
        </ModalFrame>
      ) : null}
    </section>
  );
}
